import * as $ from 'jquery';
import 'bootstrap';

export class activateAccount {
  private hideMobileIcon: boolean = false;
  private imageData: any = {type: 'file', data: null, name: null};
  private cameraView: any = 'rear';
  private constraints: any = {
      video: {
        width: 720,
        height: 550,
        facingMode: "user"
      },
    };
    initializeManualAndCameraSettings(): any {
      let self = this;
      // if ((/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
      //   $('.flip-camera').addClass("showclass");
      //   $('.flip-camera').removeClass("hideclass");
      // } else {
      //   $('.flip-camera').removeClass("showclass");
      //   $('.flip-camera').addClass("hideclass");
      // }
      // hide and show mobile icon
      if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
        self.hideMobileIcon = false;
      } else {
        self.hideMobileIcon = true;
      }
      if(self.hideMobileIcon) {
        $('.via-webcam').addClass('hideclass');
        $('.via-webcam').removeClass('showclass');
        $('.warning-text').addclass('showclass');
        $('.warning-text').removeClass('hideclass');
      }
      // end logic of hide mobile icon
      // upload files manually
      $('#actual-btn1').change(function() {
        $($(this)[0].nextSibling.nextSibling).html(this.files[0].name);
        self.imageData.data = this.files;
        self.imageData.type = 'file';
        let image:any = document.getElementById("desktop-image-document1");
        image.src = null;
        image.classList.remove('showclass');
        image.classList.add('hideclass');
      });
      $('#mob-actual-btn1').change(function() {
        $($(this)[0].nextSibling.nextSibling).html(this.files[0].name);
        self.imageData.data = this.files;
        self.imageData.type = 'file';
        let image:any = document.getElementById("image-document1");
        image.src = null;
        image.classList.remove('showclass');
        image.classList.add('hideclass');
      });
      $('.desktop-submit').click(() => {
        let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
        let formData = new FormData();
        if(studentEnrichIdCookieVal && studentEnrichIdCookieVal.length > 0) {
          formData.append('enrichId', studentEnrichIdCookieVal[2]);
        } else {
          formData.append('enrichId', null);
        }
        formData.append('fileData', self.imageData.data[0]);
        formData.append('fileType', self.imageData.data[0].type);
        formData.append('fileName', self.imageData.data[0].name);
        formData.append('captureType', self.imageData.type);
        $.ajax({
					type: 'POST',
					url: "/bin/services/new/updateStudentFileUploadData",
					data: formData,
          contentType: false,
          processData: false, /// Add this line without processing parameters
					success: function (msg: any) {
						let json: any = null;
						if (typeof msg === 'string') {
							json = JSON.parse(msg);
						} else {
							json = msg;
						}						
						if (json.code == 'ERROR') {
              $('.success-validate').html("");
              $('.error-validate').html("Error. Please try after some time.");
						} else {
              let url = $('.redirect-url').val();
              window.location.href = url;
            }
					},
					error: function (error: any) {
            $('.success-validate').html("");
						$('.error-validate').html("Error. Please try after some time.");
					}
				});
      });
      $('.mob-submit').click(() => {
        let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
        let formData = new FormData();
        if(studentEnrichIdCookieVal && studentEnrichIdCookieVal.length > 0) {
          formData.append('enrichId', studentEnrichIdCookieVal[2]);
        } else {
          formData.append('enrichId', null);
        }
        if(self.imageData.type === "camera") {
          let base64 = self.imageData.data.split(',')
          let imageType = base64[0].split('/')[1].split(';')[0];
          formData.append('fileData', base64[1]);
          formData.append('fileType', imageType);
          formData.append('fileName', self.imageData.name);
          formData.append('captureType', self.imageData.type);
        } else {
          formData.append('fileData', self.imageData.data[0]);
          formData.append('fileType', self.imageData.data[0].type);
          formData.append('fileName', self.imageData.data[0].name);
          formData.append('captureType', self.imageData.type);
        }
        $.ajax({
					type: 'POST',
					url: "/bin/services/new/updateStudentFileUploadData",
					data: formData,
          contentType: false,
          processData: false, /// Add this line without processing parameters
					success: function (msg: any) {
						let json: any = null;
						if (typeof msg === 'string') {
							json = JSON.parse(msg);
						} else {
							json = msg;
						}						
						if (json.code == 'ERROR') {
              $('.mob-success-validate').html("");
              $('.mob-error-validate').html("Error. Please try after some time.");
						} else {
              let url = $('.redirect-url').val();
              window.location.href = url;
            }
					},
					error: function (error: any) {
            $('.mob-success-validate').html("");
						$('.mob-error-validate').html("Error. Please try after some time.");
					}
				});
      });
    }
    captureImagesInMobilesView() {
      let self = this;
      const captureVideoButton1: any = document.querySelector('.start-video1');
      const captureDesktopVideoButton2: any = document.querySelector('.desktop-start-video1');
      let screenshotButton: any = null;
      let video: any = null;
      let img: any = null;
      let canvas: any = null;
      let elem: any = null;
      let image: any = null;
      let flipView: any = document.querySelector('.flip-camera');
      captureVideoButton1.onclick = function () {
        $('.mob-error-validate').html("");
        let elem = document.getElementById('screenshot1');
        elem.classList.add('showclass');
        elem.classList.remove('hideclass');
        let form: any = document.getElementsByClassName('mob-activate-form');
        form[0].classList.add('hideclass');
        form[0].classList.remove('showclass');
        elem.classList.add('bounce-in-right');
        setTimeout(() => {
          elem.classList.remove('bounce-in-right');
        }, 1000)
        video = elem.querySelector("video");
        screenshotButton = elem.querySelector(".screenshot-button");
        canvas = document.createElement("canvas");
        image = document.getElementById("image-document1");
        screenshotButton.onclick = video.onclick = function () {
          if($("#mob-image-name").val() === null || $("#mob-image-name").val() === "") {
            $(".error-item").addClass("showclass");
            $(".error-item").removeClass("hideclass");
            return;
          }
          $(".error-item").addClass("hideclass");
          $(".error-item").removeClass("showclass");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas.getContext("2d").drawImage(video, 0, 0);
          // Other browsers will fall back to image/png
          image.src = canvas.toDataURL("image/webp");
          image.classList.add('showclass');
          image.classList.remove('hideclass');
          video.srcObject.getTracks()[0].stop();
          elem.classList.add('hideclass');
          elem.classList.remove('showclass');
          form[0].classList.add('showclass');
          form[0].classList.remove('hideclass');
          form[0].classList.add('bounce-in-right');
          setTimeout(() => {
            form[0].classList.remove('bounce-in-right');
          }, 1000)
          // $('.manual-upload1').addClass('hideclass');
          // $('.manual-upload1').removeClass('showclass');
          self.imageData.data = image.src;
          self.imageData.type = 'camera';
          self.imageData.name = $("#mob-image-name").val();
          $('.manual-upload1').find('#file-chosen1').html(self.imageData.name);
        };
        navigator.mediaDevices
          .getUserMedia(self.constraints)
          .then(handleSuccess)
          .catch(handleError);
        flipView.onclick = function() {
          video.srcObject.getTracks()[0].stop();
          self.cameraView = self.cameraView == "rear" ? "front" : "rear";
          if(self.cameraView == "rear") {
            self.constraints = {
              video: {
                width: 720,
                height: 550,
                facingMode: {
                  exact: 'environment'
                }
              },
            }
          } else if(self.cameraView == "front") {
            self.constraints = {
              video: {
                width: 720,
                height: 550,
                facingMode: 'user',
              },
            }
          }
          navigator.mediaDevices
            .getUserMedia(self.constraints)
            .then(handleSuccess)
            .catch(handleError);
        };
      };
      captureDesktopVideoButton2.onclick = function () {
        // feature is not in scope but dont removed the code
        // let elem = document.getElementById('desktop-screenshot1');
        // elem.classList.add('showclass');
        // elem.classList.remove('hideclass');
        // let form: any = document.getElementsByClassName('activate-form');
        // form[0].classList.add('hideclass');
        // form[0].classList.remove('showclass');
        // elem.classList.add('bounce-in-right');
        // setTimeout(() => {
        //   elem.classList.remove('bounce-in-right');
        // }, 1000)
        // video = elem.querySelector("video");
        // screenshotButton = elem.querySelector(".screenshot-button");
        // canvas = document.createElement("canvas");
        // image = document.getElementById("desktop-image-document1");
        // screenshotButton.onclick = video.onclick = function () {
        //   canvas.width = video.videoWidth;
        //   canvas.height = video.videoHeight;
        //   canvas.getContext("2d").drawImage(video, 0, 0);
        //   // Other browsers will fall back to image/png
        //   image.src = canvas.toDataURL("image/webp");
        //   image.classList.add('showclass');
        //   image.classList.remove('hideclass');
        //   video.srcObject.getTracks()[0].stop();
        //   elem.classList.add('hideclass');
        //   elem.classList.remove('showclass');
        //   form[0].classList.add('showclass');
        //   form[0].classList.remove('hideclass');
        //   form[0].classList.add('bounce-in-right');
        //   setTimeout(() => {
        //     form[0].classList.remove('bounce-in-right');
        //   }, 1000);
        //   $('#desktop-file-chosen1').html('Image captured');
        //   self.imageData.data = image.src;
        //   self.imageData.type = 'camera';
        // };
        // navigator.mediaDevices
        //   .getUserMedia(constraints)
        //   .then(handleSuccess)
        //   .catch(handleError);
      };
      
      function handleSuccess(stream : any) {
        video.srcObject = stream;
      }
      function handleError(error : any) {
        console.error("Error: ", error);
      }
    }
}

let scope:Element = document.querySelector('#activate-account-form');
declare const window: any;
if (scope) {
	try {
	let activateAcc = new activateAccount();
  activateAcc.initializeManualAndCameraSettings();
  activateAcc.captureImagesInMobilesView();
	} catch(e) {console.error(e);}
}	

